<section class="login">
  <button (click)="login()" color="primary" mat-fab extended>
    Sign in with Google
  </button>
</section>
<section class="logo">
  <img src="/assets/icon.png" alt="logo" />
  <h2>Admin</h2>
</section>
